import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../components/Footer';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft, FiInfo } = FiIcons;

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-[#004d44]">
      <nav className="fixed top-0 w-full z-50 bg-white/90 backdrop-blur-md shadow-sm py-4">
        <div className="max-w-7xl mx-auto px-4 flex justify-between items-center">
          <a href="/" className="flex items-center gap-2 group">
            <div className="w-8 h-8 rounded-lg bg-[#00a48c] text-white flex items-center justify-center font-black">S</div>
            <span className="text-xl font-black tracking-tight">Simulation Rendement PER</span>
          </a>
          <a href="/" className="flex items-center gap-2 text-sm font-bold text-[#00a48c] hover:underline">
            <SafeIcon icon={FiArrowLeft} /> Retour à l'accueil
          </a>
        </div>
      </nav>

      <main className="pt-32 pb-20 px-4">
        <div className="max-w-4xl mx-auto">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 rounded-2xl bg-[#f0fcf9] text-[#00a48c] flex items-center justify-center text-2xl">
                <SafeIcon icon={FiInfo} />
              </div>
              <h1 className="text-4xl font-black uppercase tracking-tight">Mentions Légales</h1>
            </div>

            <div className="prose prose-slate max-w-none space-y-8 text-gray-600 font-medium leading-relaxed">
              <section className="bg-[#f0fcf9]/30 p-8 rounded-[2rem] border border-[#f0fcf9]">
                <h2 className="text-xl font-black text-[#004d44] mb-4 uppercase">1. Éditeur du site</h2>
                <p>Le site <strong>simulation-rendement-per.fr</strong> est édité par :</p>
                <p className="mt-2">
                  <strong>GROUPE VAILLANCE CONSEIL</strong><br />
                  Société par actions simplifiée au capital de 10 000 €<br />
                  Siège social : 25 rue de Ponthieu, 75008 Paris, France<br />
                  Immatriculée au RCS de Paris sous le numéro 498 733 104<br />
                  Code NAF : 6622Z (Activités des agents et courtiers d'assurances)
                </p>
              </section>

              <section>
                <h2 className="text-xl font-black text-[#004d44] mb-4 uppercase">2. Agrégations et immatriculations</h2>
                <p>
                  Le Cabinet est immatriculé au Registre Unique des Intermédiaires en Assurance, Banque et Finance (ORIAS) sous le numéro <strong>07030598</strong> (consultable sur www.orias.fr) en qualité de :
                </p>
                <ul className="list-disc pl-5 space-y-2 mt-4">
                  <li>Courtier d'assurance ou de réassurance (COA)</li>
                  <li>Mandataire non exclusif en opérations de banque et en services de paiement (MOBSP)</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-black text-[#004d44] mb-4 uppercase">3. Hébergement et nom de domaine</h2>
                <p>
                  Le nom de domaine est enregistré auprès de OVH SAS, 2 rue Kellermann - 59100 Roubaix - France.
                </p>
                <p>
                  Le site est hébergé par Vercel Inc.<br />
                  Adresse : 340 S Lemon Ave #4133, Walnut, CA 91789, USA.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-black text-[#004d44] mb-4 uppercase">4. Autorité de contrôle</h2>
                <p>
                  L'activité d'intermédiaire en assurance est placée sous le contrôle de l'Autorité de Contrôle Prudentiel et de Résolution (ACPR) :<br />
                  4 Place de Budapest, CS 92459, 75436 Paris Cedex 09.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-black text-[#004d44] mb-4 uppercase">5. Conception et Marketing Digital</h2>
                <p>
                  La conception, la réalisation technique ainsi que la gestion des campagnes publicitaires (paid marketing) sont assurées par l'agence <a href="https://01st.info" target="_blank" rel="noopener noreferrer" className="font-bold text-[#006b5a] hover:text-[#00a48c] transition-colors"><strong>01ST DIGITAL SOLUTIONS</strong></a>.
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MentionsLegales;